const theme = {
    palette: {
        primary: {
            /* light: '#757d96', */
            main: '#2e3958'
            /* ,
            dark: '#4f5a76',
            contrastText: '#fff' */
        },
        secondary: {
            //main: '#f4511e',
            main: '#00d4ff',
            contrastText: '#fff'
        },
        error: {
            main: '#e7511e',
            contrastText: '#fff'
        },
        warning: {
            main: '#ff9700',
            contrastText: '#fff'
        },
        info: {
            main: '#691340',
            contrastText: '#fff'
        },
        success: {
            main: '#ec7559',
            contrastText: '#fff'
        },
        default: '#f0f0f0'

    },
    typography: {
        fontFamily: 'urw-din, "Helvetica Neue", Helvetica, Arial, sans-serif',
    },
    overrides: {
        MuiDialogActions: {
            root: {
                padding: '15px 25px 25px 25px',
            },
        },
        MuiTextField: {
            root: {
                marginTop: 0,
                marginBottom: 0,
            },
        },
        MuiButton: {
            colorInherit: {
                backgroundColor: '#e7511e',
                color: '#fff',
                '&:hover': {
                    backgroundColor: "#a13815",
                    color: '#fff',
                }
            },
        },
        MuiFab: {
            colorInherit: {
                backgroundColor: '#e7511e',
                color: '#fff',
                '&:hover': {
                    backgroundColor: "#a13815",
                    color: '#fff',
                }
            }
        },
        MuiTableCell: {
            head: {
                backgroundColor: '#062a54',
                color: '#fff'
            },
            root: {
                whiteSpace: 'pre-wrap'
            }
        },
        /* MuiCardContent: {
            root: {
                height: 'calc(100vh - 180px)'
            }
        }, */
        MuiCardHeader: {
            root: {
                backgroundColor: '#062a54',
                color: '#fff'
            }
        },
        MuiStepIcon: {
            root: {
                '&$completed': {
                    color: 'green',
                }
            }
        }
    }
}
export default theme;